
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ContactHero from './components/ContactHero';
import QuickContactCards from './components/QuickContactCards';
import ContactForm from './components/ContactForm';
import MapSection from './components/MapSection';
import FAQSection from './components/FAQSection';

export default function Contact() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <ContactHero />
      <QuickContactCards />
      <ContactForm />
      <MapSection />
      <FAQSection />
      <Footer />
    </div>
  );
}
